import { Component, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as L from 'leaflet';
import { catchError, EMPTY } from 'rxjs';
import { AutocompleteService } from '@app/core/services/autocomplete.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrl: './map.component.css',
})
export class MapComponent implements OnInit, OnDestroy {
  @Input() public darReference?: string | null;
  @ViewChild('mapEl', { static: true }) private readonly mapEl!: ElementRef<HTMLDivElement>;

  private map?: L.Map;
  private readonly autocompleteService = inject(AutocompleteService);

  public ngOnInit(): void {
    if (!this.darReference) return;

    // The backend resolves the access point and projects it to WGS84, so no
    // coordinate conversion or provider specific fallback is needed here.
    this.autocompleteService.getCoordinates(this.darReference).pipe(
      catchError(() => EMPTY)
    ).subscribe(coordinates => {
      if (!coordinates) return;
      this.renderMap(coordinates.latitude, coordinates.longitude);
    });
  }

  public ngOnDestroy(): void {
    this.map?.remove();
  }

  private renderMap(lat: number, lon: number): void {
    const el = this.mapEl.nativeElement;

    const map = L.map(el, {
      center: [lat, lon],
      zoom: 17,
      scrollWheelZoom: false,
      attributionControl: false,
    });
    this.map = map;

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    }).addTo(map);

    L.marker([lat, lon]).addTo(map);

    el.addEventListener('wheel', (e: WheelEvent) => {
      if (!e.ctrlKey) return;
      e.preventDefault();
      if (e.deltaY < 0) map.zoomIn();
      else map.zoomOut();
    }, { passive: false });
  }
}
